<template>
  <div class="custom-main custom-theme">
    <a-form class="ant-advanced-search-form">
      <div class="gpws-menu-title">
        <span>&nbsp;</span>退药
      </div>
      <a-row class="searchrow width-style-auto">
        <a-col span="5">
          <a-form-item label="就诊科室">
            <a-select v-model="search.departId" placeholder="请选择科室" @select="departTreeSelect">
              <template v-for="item in init.departments">
                <template v-if="(item.children||[]).length == 0">
                  <a-select-option :key="item.key" :value="item.value">{{ item.title }}</a-select-option>
                </template>
                <template v-else>
                  <a-select-opt-group :key="item.key" :label="item.title">
                    <a-select-option v-for="e in item.children" :key="e.key" :value="e.value">{{ e.title }}</a-select-option>
                  </a-select-opt-group>
                </template>
              </template>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col span="5">
          <a-form-item label="就诊医生">
            <a-select v-model="search.doctorId">
              <a-select-option value="">--请选择--</a-select-option>
              <a-select-option v-for="item in init.doctors" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col span="6">
          <a-form-item label="就诊时间">
            <a-date-picker v-model="search.visitDate" placeholder="请选择就诊日期"/>
          </a-form-item>
        </a-col>
        <a-col span="8">
          <a-form-item style="float: right;" :colon="false">
            <span slot="label" class="search-label">搜索</span>
            <a-input v-model="search.keyword" placeholder="请输入患者姓名模糊检索">
              <img slot="addonAfter" src="../../../assets/img/search.png" style="height:32px;object-fit: cover;cursor: pointer;" @click="searchAction"/>
            </a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-table size="middle" :columns="grid.columns" :loading="grid.loading" :rowSelection="{fixed:true}" rowKey="id" :dataSource="grid.data"
             :scroll="{ x: '100%' }" :pagination="grid.pagination" @change="gridChangeAction">
        <span slot="index" slot-scope="text, record, index">
           {{(((grid.pagination.current -1 ) * grid.pagination.pageSize) + index + 1) }}
        </span>
      <span slot="amount" slot-scope="text, record, index" style="color: red;">
        {{ record.amount.toFixed(2) }}
      </span>
      <span slot="credit" slot-scope="text, record, index" style="color: red;">
        {{ record.credit.toFixed(2) }}
      </span>
      <span slot="payment" slot-scope="text, record, index" style="color: red;">
        {{ record.payment.toFixed(2) }}
      </span>
      <span slot="operate" slot-scope="text, record, index">
        <img src="../../../assets/img/r-drug.png" style="cursor: pointer;user-select: none;" @click="()=>refundDrugAction(record.id)"/>
      </span>
    </a-table>
    <a-drawer placement="right" :closable="false" :mask-closable="false" :visible="drawer.visible" width="900">
      <div slot="title" class="gpws-drawer-title-span">
        <div class="gpws-drawer-close" @click="()=>onDrawerClose()"><a-icon type="close" style="margin-right: 3px" />关闭</div>
        <span class="gpws-drawer-title">处方退药</span>
        <span></span>
      </div>
      <a-spin :spinning="loading" tip="正在进行处方退药....">
        <a-form :form="drawer.form" layout="horizontal">
          <a-card size="small" :bordered="false" :head-style="{'borderBottom':'none', 'paddingLeft':'24px', 'paddingRight':'24px'}" :body-style="{'padding':'0px'}">
            <span slot="title" class="gpws-model-title">
              <img src="../../../assets/img/split.png" style="margin-right: 9px;user-select: none;"/>患者信息
            </span>
            <a-row>
              <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
                <a-form-item label="姓名" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  {{ drawer.record.name }}
                </a-form-item>
              </a-col>
              <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
                <a-form-item label="年龄" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  {{ drawer.record.age }}
                </a-form-item>
              </a-col>
              <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
                <a-form-item label="身份证号" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  {{ drawer.record.idcard }}
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
                <a-form-item label="性别" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  {{ drawer.record.sex }}
                </a-form-item>
              </a-col>
              <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
                <a-form-item label="孕否" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  {{ drawer.record.gestate?'孕':'否' }}
                </a-form-item>
              </a-col>
              <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
                <a-form-item label="电话号码" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 4, xl: 4, xxl: 4 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  {{ drawer.record.phone }}
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
                <a-form-item label="婚否" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  {{ drawer.record.marriageName }}
                </a-form-item>
              </a-col>
              <a-col :xxl="17" :xl="17" :lg="17" :md="24" :sm="24" :xs="24">
                <a-form-item label="详细地址" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 3, xl: 3, xxl: 3 }" :wrapper-col="{sm: 24, md: 12, lg: 19, xl: 19, xxl: 19 }">
                  {{ drawer.record.address }}
                </a-form-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
                <a-form-item label="就诊类型" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  {{ drawer.record.visitType }}
                </a-form-item>
              </a-col>
              <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
                <a-form-item label="就诊科室" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  {{ drawer.record.department }}
                </a-form-item>
              </a-col>
              <a-col :xxl="10" :xl="10" :lg="10" :md="12" :sm="12" :xs="24">
                <a-form-item label="就诊医生" class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 14, xl: 14, xxl: 14 }">
                  {{ drawer.record.doctor }}
                </a-form-item>
              </a-col>
            </a-row>
            <a-row style="margin-top: 20px;margin-bottom: 20px;background: #F3F3F3;border-radius: 4px;">
              <a-col :xxl="7" :xl="7" :lg="7" :md="12" :sm="12" :xs="24">
                <a-form-item class="gpws-m-b-2" :label-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }" :wrapper-col="{sm: 24, md: 12, lg: 16, xl: 16, xxl: 16 }">
                  <span slot="label" style="line-height: 60px;">门诊金额</span>
                  <span style="color: #D02F2F;font-size: 22px;line-height: 60px;font-weight: 500;">¥&nbsp;{{ (undefined != drawer.record.amount && null != drawer.record.amount)?drawer.record.amount.toFixed(2):'-' }}</span>
                </a-form-item>
              </a-col>
              <a-col :offset="12" :xxl="5" :xl="5" :lg="5" :md="12" :sm="12" :xs="24">
                <a-form-item style="text-align: center;margin-bottom: 2px;">
                  <span style="line-height: 60px;">
                    <img src="../../../assets/img/r-drug.png" style="cursor: pointer;user-select: none;margin-right: 24px;" @click="()=>saveRefundDrugAction()"/>
                    <img src="../../../assets/img/close.png" style="cursor: pointer;user-select: none;" @click="()=>onDrawerClose()"/>
                  </span>
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
          <a-collapse :bordered="false" :accordion="true" expand-icon-position="right" style="margin-top: 10px;background:#fff;overflow-y: auto;">
            <template v-for="item in (drawer.record.recipes||[]).filter(m => m.type != 'CM')">
              <a-collapse-panel v-if="item.dispose == 'LOCAL'" :key="item.code" style="background: #ffffff;">
               <span slot="header">
                  <a-row>
                    <a-col span="2">
                      <a-checkbox @change="(e) =>recipeRefund(e, item.code)" style="color:#1890ff;">全退</a-checkbox>
                    </a-col>
                    <a-col span="8" class="gpws-model-title">
                      {{ item.typeName }}
                    </a-col>
                    <a-col span="4" style="text-align: right;"><span style="color: #D02F2F;">{{ item.drugs.length }}</span> 项药品</a-col>
                    <a-col span="4" style="text-align: right;">{{ ((item.type == 'CM' && item.doses > 0)? ('付数:'+item.doses+'付'):((item.type != 'CM' && item.days > 0)?('天数:'+item.days+'天'):'')) }}</a-col>
                    <a-col span="6" style="text-align: center;"><span style="color: #D02F2F;">¥：{{ item.amount.toFixed(2) }}</span></a-col>
                  </a-row>
                </span>
                <a-table :columns="drawer.columns" :data-source="item.drugs" row-key="drugId" size="small" :rowSelection="{fixed:true, selectedRowKeys:drawer.drugIds, getCheckboxProps:function(record) { return {props: {disabled: true,}}}}" :pagination="false">
                  <span slot="refundQty" slot-scope="text, row, index">
                    <a-form-item style="margin-bottom: 0px;">
                      <a-input-number :min="0" :step="0.01" :max="(row.salesQty-row.refundQty)" v-decorator="[`refund${row.drugId}`, {rules: [{ required: (drawer.drugIds.includes(row.drugId)), message:'请输入退药数量' }], initialValue: row.qty }]" placeholder="请输入退药数量" @change="(value) =>refundDrugQty(value, item.code, row.drugId)"/>
                    </a-form-item>
                  </span>
                  <span slot="refundAmount" slot-scope="text, row, index" style="color: red;">
                    {{(undefined == row.refundAmount || null == row.refundAmount)?'-':row.refundAmount.toFixed(2) }}
                  </span>
                </a-table>
                <a-row>
                  <a-col style="padding-left: 40px;line-height: 32px; height: 32px;">
                    {{ item.usage }}
                  </a-col>
                </a-row>
                <a-row>
                  <a-col style="padding-left: 40px;line-height: 32px; height: 32px;">
                    {{ item.advice }}
                  </a-col>
                </a-row>
              </a-collapse-panel>
            </template>
          </a-collapse>
        </a-form>
      </a-spin>
    </a-drawer>
  </div>
</template>
<script>
export default {
  name: "OutpatientRefundDrug",
  data() {
    return {
      loading: false,
      current:{},
      init:{
        departments:[],
        doctors:[],
        methods:[]
      },
      search:{
        departId:'',
        doctorId:'',
        visitDate:'',
        keyword:''
      },
      grid: {
        loading: false,
        columns: columns,
        data: [],
        pagination: this.$pagination
      },
      drawer:{
        visible:false,
        codes:[],
        drugIds:[],
        record:{},
        form: this.$form.createForm(this),
        columns: drugColumns
      }
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "门诊",
      path: ""
    },{
      text: "发药",
      path: ""
    },{
      text: "退药",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    const self = this;
    this.current = JSON.parse(localStorage.getItem("curruser"));

    this.getDepartmentTree({params:{organId:this.current.organId}}, function (res) {
      let departments=[];
      res.forEach(function (e){
        departments.push({title:e.name, value:e.id, key:e.id, children:self.children(e), type:e.type});
      });
      self.init.departments = departments;
    });

    this.searchAction();
  },
  methods:{
    saveRefundDrugAction:function (){
      const self = this;
      this.drawer.form.validateFields((err, values) => {
        if (!err) {
          if(undefined == self.drawer.drugIds || null == self.drawer.drugIds || self.drawer.drugIds.length <= 0){
            self.$message.info({content: '请选择需要退药的处方药品.', duration: 2});
            return;
          }

          let drugs=[];
          self.drawer.record.recipes.forEach(function (item, index) {
            item.drugs.forEach(function (e, i) {
              if(self.drawer.drugIds.includes(e.drugId)){
                drugs.push({recipeCode:item.code, drugId:e.drugId, qty:e.refundQty});
              }
            });
          });

          this.loading = true;
          let params = {id:self.drawer.record.id, drugs:drugs};
          self.$axios.post('/api/clinic/outpatient/refunddrug', params).then(function(res){
            self.loading = false;
            if(res.msg.flag == 0){
              self.$message.success({content: '门诊处方退药成功.', duration: 2});
              self.onDrawerClose();
              self.searchAction();
            }else{
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(res){
            self.loading = false;
          });
        }
      });
    },
    recipeRefund:function(e, code){
      const self = this;
      if(e.target.checked){
        this.drawer.record.recipes.forEach(function (item, index) {
          if(item.code == code){
            item.drugs.forEach(function (e, i) {
              if(!self.drawer.drugIds.includes(e.drugId)){
                self.drawer.drugIds.push(e.drugId);
              }
              e.qty = e.salesQty;
              e.refundAmount = e.amount;
              item.drugs.splice(i, 1, e);
            });
          }
        });
      }else{
        this.drawer.record.recipes.forEach(function (item, index) {
          if(item.code == code){
            item.drugs.forEach(function (e, i) {
              if(self.drawer.drugIds.includes(e.drugId)){
                let index = -1;
                self.drawer.drugIds.forEach(function (m, n){
                  if(e.drugId == m){
                    index = n;
                  }
                });

                if(index >= 0){
                  self.drawer.drugIds.splice(index, 1);
                }
              }
              e.qty = undefined;
              e.refundAmount = undefined;
              item.drugs.splice(i, 1, e);
            });
          }
        });
      }
    },
    refundDrugQty:function(value, code, drugId){
      if(parseFloat(value) > 0){
        if(!this.drawer.drugIds.includes(drugId)){
          this.drawer.drugIds.push(drugId);
        }
      }else{
        if(this.drawer.drugIds.includes(drugId)){
          let index = -1;
          this.drawer.drugIds.forEach(function (e, i){
            if(drugId == e){
              index = i;
            }
          });

          if(index >= 0){
            this.drawer.drugIds.splice(index, 1);
          }
        }
      }

      this.drawer.record.recipes.forEach(function (item, index) {
        if(item.code == code){
          item.drugs.forEach(function (e, i) {
            if(e.drugId == drugId){
              e.qty = parseFloat(value);
              e.refundAmount = e.price * parseFloat(value);
              item.drugs.splice(i, 1, e);
            }
          });
        }
      });
    },
    refundDrugAction:function (id){
      const self = this;
      this.$axios.get('/api/clinic/outpatient/' + id).then(function (res) {
        if (res.msg.flag == 0) {
          if(undefined != res.biz && null != res.biz){
            self.drawer.record = res.biz;
            self.drawer.visible = true;
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      }, function (res) {
      });
    },
    onDrawerClose:function (){
      this.drawer.record= {};
      this.drawer.codes = [];
      this.drawer.drugIds = [];
      this.drawer.visible = false;
    },
    //科室选择
    departTreeSelect: function (value) {
      if (undefined != value && null != value && '' != value) {
        this.loadDepartDoctor(value);
      }
    },
    //获取科室医生
    loadDepartDoctor:function (id) {
      const self = this;
      this.init.doctors=[];
      if(undefined != id && null != id && '' != id){
        this.$axios.get('/api/clinic/' + this.current.organId +'/' + id + '/doctors', {params:{business:'OUTPATIENT'}}).then(function (res) {
          if (res.msg.flag == 0 && undefined != res.biz && null != res.biz && res.biz.length > 0) {
            self.init.doctors = [];
            res.biz.forEach(function (e) {
              self.init.doctors.push({id:e.id, name:e.name});
            });
          }
        }, function (res) {
        });
      }
    },
    buildParams:function (){
      let visitDate ='';
      if(undefined != this.search.visitDate && null != this.search.visitDate && '' != this.search.visitDate){
        visitDate = this.formatDate(new Date(this.search.visitDate));
      }
      return {
        'entity.departId' : this.search.departId, 'entity.doctorId' : this.search.doctorId, 'entity.visitDate' : visitDate,
        'entity.keyword' : this.search.keyword, 'entity.organId': this.current.organId
      };
    },
    /**
     * 查询按钮动作
     */
    searchAction: function () {
      Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
      let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 分页条操作
     */
    gridChangeAction: function (pagination, filters, sorter) {
      Object.assign(this.grid, {pagination: pagination});
      let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
      this.loadGrid(params);
    },
    /**
     * 查询
     */
    loadGrid:function(params){
      const self = this;
      self.grid.loading = true;
      self.$axios.get('/api/clinic/refunddrug/outpatients', {params: params}).then(function(res){
        self.grid.loading = false;
        if(res.msg.flag == 0){
          if(null == res.biz || res.biz.empty){
            self.$message.info({content: res.msg.message, duration: 2});
            Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
          }else{
            Object.assign(self.grid, {data: res.biz.data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
          }
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(){
        self.grid.loading = false;
      });
    },
    children:function (e) {
      const self = this;
      let result =[];
      if(undefined != e.children && null != e.children && e.children.length > 0){
        e.children.forEach(function (m){
          result.push({title:m.name, value:m.id, key:m.id, children:self.children(m), type:m.type});
        });
      }
      return result;
    }
  }
}

const drugColumns =[
  {
    title: '药品名称',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '规格',
    dataIndex: 'spec',
    key: 'spec',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '剂型',
    dataIndex: 'form',
    key: 'form',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '数量',
    dataIndex: 'salesQty',
    key: 'salesQty',
    align: 'right',
    width: 100,
    customRender:(text, record, index) =>{
      return (record.salesQty-record.refundQty).toFixed(2);
    }
  },
  {
    title: '单位',
    dataIndex: 'salesUnit',
    key: 'salesUnit',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '退药数量',
    key:'refundQty',
    align: 'right',
    fixed: 'right',
    scopedSlots: {customRender: 'refundQty'},
    width: 100
  },
  {
    title: '退药金额',
    key: 'refundAmount',
    align: 'right',
    fixed: 'right',
    width: 100,
    scopedSlots: {customRender: 'refundAmount'}
  }
];
const columns =[
  {
    title: '序号',
    align: 'center',
    scopedSlots: {customRender: 'index'},
    width: 60
  },
  {
    title: '门诊单号',
    dataIndex: 'code',
    key: 'code',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '患者姓名',
    dataIndex: 'name',
    key: 'name',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '性别',
    dataIndex: 'sex',
    key: 'sex',
    width: 80,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '年龄',
    dataIndex: 'age',
    key: 'age',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '处方类型',
    dataIndex: 'model',
    key: 'model',
    align: 'center',
    width: 100,
    customRender:(text, record, index) =>{
      return record.model == null || record.model == undefined || record.model == '' ? '-' : (record.model == 'ROAM'?'流转处方':'本院处方');
    }
  },
  {
    title: '就诊类型',
    dataIndex: 'visitType',
    key: 'visitType',
    align: 'center',
    width: 100,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '就诊时间',
    dataIndex: 'recipeTime',
    key: 'recipeTime',
    align: 'center',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '就诊科室',
    dataIndex: 'department',
    key: 'department',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '就诊医生',
    dataIndex: 'doctor',
    key: 'doctor',
    width: 150,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '联系电话',
    dataIndex: 'phone',
    key: 'phone',
    width: 120,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '详细地址',
    dataIndex: 'address',
    key: 'address',
    width: 200,
    customRender:(text, record, index) =>{
      return text == null || text == undefined || text == '' ? '-' : text;
    }
  },
  {
    title: '门诊费',
    key: 'amount',
    align: 'right',
    fixed: 'right',
    width: 80,
    scopedSlots: {customRender: 'amount'}
  },
  {
    title: '赊账',
    key: 'credit',
    align: 'right',
    fixed: 'right',
    width: 80,
    scopedSlots: {customRender: 'credit'}
  },
  {
    title: '实收',
    key: 'payment',
    align: 'right',
    fixed: 'right',
    width: 80,
    scopedSlots: {customRender: 'payment'}
  },
  {
    title: '操作',
    key: 'id',
    align: 'center',
    fixed: 'right',
    width: 100,
    scopedSlots: {customRender: 'operate'}
  }
]
</script>

<style scoped>
.gpws-m-b-2{
  margin-bottom: 2px!important;
}
</style>
